const InfoIcon = ({clr}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width={15} height={15} fill="none">
    <path
      fill={clr || "#BABABA"}
      d="M7.874 2.187a5.688 5.688 0 1 0 5.688 5.687 5.694 5.694 0 0 0-5.688-5.687Zm-.11 2.625a.656.656 0 1 1 0 1.312.656.656 0 0 1 0-1.312Zm.548 6.125h-.438a.437.437 0 0 1-.437-.438V7.874a.437.437 0 1 1 0-.875h.437a.438.438 0 0 1 .438.438v2.625a.438.438 0 0 1 0 .875Z"
    />
  </svg>
)

export default InfoIcon